import { FunctionComponent } from 'react';

export enum ExcessCode {
  VoluntaryAmt = 'VoluntaryAmt',
  BaseAmt = 'BaseAmt',
  PortableContentsCover = 'PortableContentsCover',
  UnspecifiedPortablesExcess = 'UnspecifiedPortablesExcess',
  SpecifiedPortablesExcess = 'SpecifiedPortablesExcess',
}

export type Excess = {
  id: string;
  type: string;
  code?: string;
  amount: number;
  name?: string;
};

export type BusinessErrorDetail = {
  code: string;
  msg: string;
  id: string;
  ref: string;
  type: string;
};

export interface QuoteErrorDetails {
  status: string;
  type: string;
  payload: BusinessErrorDetail;
}

export type ValueRange = {
  lowerLimit: string;
  upperLimit: string;
};

export type Extra = {
  code: string;
  label: string;
  image: string;
  additionalText?: string;
  content: FunctionComponent;
  summaryLabel?: string;
};

export type GovernmentCharges = {
  gst: number;
  fireServicesLevy: number;
  stampDuty: number;
};

export type Premium = {
  price: string;
  firstInstalment: string;
  monthlyInstalment: string;
  annualPrice: string;
  monthlyGovernmentCharges: GovernmentCharges;
  yearlyGovernmentCharges: GovernmentCharges;
};

export type InsuranceOptionBase = {
  premium: Premium;
};
